<template>
	<div class="home">
		<div class="wrap">
			<div class="title">праздники, чтобы #боржомить</div>
			<div
				class="subline"
			>Что такое #боржомить? Это веселиться, ярко и активно проводить время, отрываться с друзьями и превращать каждый день в праздник! Впереди нас ждут новогодние праздники, а значит — лучшее время чтобы #боржомить!</div>
			<div class="button" v-scroll-to="'#main'" @click="toMain">Хочу праздника!</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		toMain() {
			ga('send', 'event', 'button', 'to main')
		},
	},
}
</script>



<style lang="less" scoped>
.home {
	width: 100%;
	height: 100vh;
	background-image: url('../assets/home.jpg');
	background-size: cover;
	background-position: center top;
	display: flex;
	justify-content: center;
	align-items: center;
}

.wrap {
	max-width: 700px;
	transform: translateY(-10%);
}

.title {
	font-size: 70px;
	text-transform: uppercase;
	line-height: 76px;
}

.subline {
	font-size: 18px;
	margin-top: 30px;
}

.button {
	width: 260px;
	height: 60px;
	text-align: center;
	font-size: 22px;
	font-weight: bold;
	line-height: 60px;
	color: #007770;
	text-transform: uppercase;
	margin: 0 auto;
	margin-top: 60px;
	background: #fff;
	cursor: pointer;
	transition: all 200ms ease;
	text-decoration: none;
}

.button:hover {
	transform: scale(1.05);
}

@media only screen and (max-device-width: 640px),
	only screen and (max-device-width: 736px),
	only screen and (max-width: 480px) {
	.home {
		width: 100%;
		height: 100vh;
	}

	.wrap {
		width: 100%;
		max-width: 700px;
		transform: translateY(0);
	}

	.title {
		font-size: 40px;
		text-transform: uppercase;
		line-height: 46px;
	}

	.subline {
		padding: 0 20px;
		font-size: 16px;
		margin-top: 30px;
	}
}
</style>